import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {TranscriptItemObject} from '@PosterWhiteboard/items/transcript-item/transcript-item.types';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';

export function useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem<T extends keyof FillObject>(key: T, isActiveWord = false): FillObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const itemObject = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];
    if (!itemObject) {
      return undefined;
    }

    if (itemObject.gitype !== ITEM_TYPE.TRANSCRIPT) {
      throw new Error(`Item isn't a transcript item`);
    }

    const transcriptItemObject = itemObject as TranscriptItemObject;

    let anySubtitleFillObject = Object.values(transcriptItemObject.subtitlesHashmap)[0].sentenceTextStyles.fill;
    if (isActiveWord) {
      anySubtitleFillObject = Object.values(transcriptItemObject.subtitlesHashmap)[0].activeWordTextStyles.fill;
    }

    if (anySubtitleFillObject[key] !== undefined) {
      return anySubtitleFillObject[key];
    }

    return undefined;
  });
}
